import { ID } from '@sdk/newsfeed/types/apiTypes';

import { QueryKey } from '@web/newsfeed/types/QueryKey';

export const getArticleQueryKey = (articleId: ID) => [QueryKey.ARTICLE, articleId] as const;

export const getArticlesQueryKey = (pageId: ID) => [QueryKey.ARTICLES, pageId] as const;

export const getArticleSearchQueryKey = (pageId: ID, query: string) =>
  [QueryKey.ARTICLE_SEARCH, pageId, query] as const;

export const getArticleCommentsQueryKey = (articleId: number) =>
  [QueryKey.ARTICLE_COMMENTS, { articleId }] as const;

export const getSeenByQueryKey = (pageId: number, articleId: number, seenByCount: number) =>
  [QueryKey.NEWSFEED_SEEN_BY, { pageId, articleId, seenByCount }] as const;

export const getLikedByByQueryKey = (
  pageId: number,
  articleId: number,
  likedByCount: number,
  commentId?: number
) => {
  if (commentId) {
    return [QueryKey.LIKED_BY, { pageId, articleId, likedByCount, commentId }] as const;
  }

  return [QueryKey.LIKED_BY, { pageId, articleId, likedByCount }] as const;
};
